import React from "react";
import globalConstants from "../shared/appConfig/globalConstants";

const DeliveryListSummary = ({
	text = globalConstants.Dashboard.DeliveryListSummaryText,
	reportsLabel = globalConstants.Dashboard.DeliveryListSummaryReportsLabel,
}) => {
	const openReportsModal = () => {
		window.dispatchEvent(
			new CustomEvent(globalConstants.CustomEventNames.OpenReportsModal),
		);
	};

	return (
		<p className="dashboard-delivery-summary">
			{text}{" "}
			<button
				type="button"
				className="dashboard-delivery-summary__reports"
				onClick={openReportsModal}
			>
				{reportsLabel}
			</button>
			.
		</p>
	);
};

export default DeliveryListSummary;
